import type { ReactNode } from 'react';

interface Props {
  eyebrow: string;
  title: string;
  description?: ReactNode;
  /** Schritte einer mehrstufigen Anmeldung, etwa Pflicht-2FA: Anmelden · Verbinden · Codes sichern. */
  steps?: readonly { label: string; state: 'done' | 'now' | 'next' }[];
}

/** Kopf der Anmeldeflächen (Board A): Eyebrow, Titel ohne Akzentwort, Satz, optional Schritte. */
export function AuthPageHeader({ eyebrow, title, description, steps }: Props) {
  return (
    <header className="flex flex-col gap-2">
      <span className="text-ink-soft font-mono text-[11px] font-semibold uppercase tracking-[0.16em]">
        {eyebrow}
      </span>
      <h1 className="font-serif text-[34px] font-bold leading-[1.05] tracking-[-0.03em] sm:text-[38px]">
        {title}
      </h1>
      {steps && (
        <ol aria-label="Schritte" className="mt-1 flex flex-wrap gap-1.5">
          {steps.map((step) => (
            <li
              key={step.label}
              aria-current={step.state === 'now' ? 'step' : undefined}
              className={
                step.state === 'now'
                  ? 'rounded-pill bg-mint text-forest-deep flex h-7 items-center px-2.5 text-[11px] font-bold'
                  : step.state === 'done'
                    ? 'rounded-pill bg-forest-soft text-forest-deep flex h-7 items-center px-2.5 text-[11px] font-bold'
                    : 'rounded-pill border-line text-ink-soft flex h-7 items-center border px-2.5 text-[11px] font-bold'
              }
            >
              {step.state === 'done' ? `✓ ${step.label}` : step.label}
            </li>
          ))}
        </ol>
      )}
      {description && <p className="text-ink-soft text-sm leading-relaxed">{description}</p>}
    </header>
  );
}
